import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import "@vtaits/react-color-picker/dist/index.css"
import "react-datepicker/dist/react-datepicker.css"
import * as Yup from "yup"
import DatePicker from "react-datepicker"

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { Countries } from "pages/Admin/ManageUser/countries"
import { activitysummary, getCompanyDetails } from "store/createTeam/action"
import moment from "moment"
import Select from "react-select"
import { customStylesSelect } from "common/data/settings"

const Organization = () => {
  const companyid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data
    ?.companysetting?.companyid

  const [registerDate, setRegisterDate] = useState(null)

  const { getcompany } = useSelector(state => ({
    getcompany: state?.createteam?.getcompany?.data,
  }))

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getCompanyDetails(companyid))
    setRegisterDate(getcompany?.registerDate)
  }, [])
  const registerDateChange = date => {
    const dates = moment(date).format("yyyy-MM-DD")
    setRegisterDate(dates)
  }

    const countrydropdown = {
    label: getcompany?.country, 
    value: getcompany?.country
   } 
   
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      organisationname: getcompany?.companyName,
      firstname: getcompany?.contactFirstName,
      lastname: getcompany?.contactLastName,
      address: getcompany?.address,
      email: getcompany?.contactEmail,
      category: getcompany?.mainCategoryName,
      subcategory: getcompany?.subCategoryName,
      country: countrydropdown,
      //country: getcompany?.country,
      active: getcompany?.active,
      domainrestrictedusers: getcompany?.domainRestrictedUsers == true,
      allowuserregistration: getcompany?.allowUserRegistration == true,
      defaultCategory: getcompany?.defaultCategory,
      defaultsubcategory: getcompany?.defaultSubCategory,
      contactname: getcompany?.contactName,
      pincode: getcompany?.postcode,
      registerDate:getcompany?.registerDate
    },
    validationSchema: Yup.object().shape({
      organisationname: Yup.string().required("Name  is Required"),
      firstname: Yup.string().required("First Name is Required"),
      lastname: Yup.string().required("Last Name is Required"),
      address: Yup.string().required("address is Required"),
      category: Yup.string().required("category is Required"),
      subcategory: Yup.string().required("subcategory is Required"),
      email: Yup.string().email("Invalid email").required("Email is Required"),
    }),
    onSubmit: values => {
      const updatesummary = {
        companyid: companyid,
        name: values.organisationname,
        contactemail: values.email,
        country: values.country?.value,
        contactfirstname: values.firstname,
        maincategoryname: values.category,
        defaultCategory: values.defaultCategory,
        postcode: values.pincode,
        address: values.address,
        contactname: values.contactname,
        registerDate: registerDate,
        contactlastname: values.lastname,
        subcategoryname: values.subcategory,
        defaultSubCategory: values.defaultsubcategory,
        allowUserRegistration: values.domainrestrictedusers,
        active: values.active,
        domainRestrictedUsers: values.domainrestrictedusers,
      }
      dispatch(activitysummary(updatesummary))
    },
  })
  const handleKeyDown =(e)=>{
    if(e.keyCode === 32){
      e.preventDefault()
    }}

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Forms" breadcrumbItem="Organisations" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Organisation Name
                            </Label>
                            <Input
                              id="organisationname"
                              name="organisationname"
                              className="form-control"
                              placeholder="Enter Organisation Name"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.organisationname || ""}
                              invalid={
                                validation.touched.organisationname &&
                                validation.errors.organisationname
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.organisationname &&
                            validation.errors.organisationname ? (
                              <FormFeedback type="invalid">
                                {validation.errors.organisationname}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>

                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">Address</Label>
                            <Input
                              id="address"
                              name="address"
                              className="form-control"
                              placeholder="Enter Address"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.address || ""}
                              invalid={
                                validation.touched.address &&
                                validation.errors.address
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.address &&
                            validation.errors.address ? (
                              <FormFeedback type="invalid">
                                {validation.errors.address}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">Email</Label>
                            <Input
                              id="email"
                              name="email"
                              className="form-control"
                              placeholder="Enter Email"
                              type="email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={
                                validation.touched.email &&
                                validation.errors.email
                                  ? true
                                  : false
                              }
                              onKeyDown={handleKeyDown}
                            />
                            {validation.touched.email &&
                            validation.errors.email ? (
                              <FormFeedback type="invalid">
                                {validation.errors.email}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">Contact Name</Label>
                            <Input
                              id="contactname"
                              name="contactname"
                              className="form-control"
                              placeholder="Enter Contact Name"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.contactname || ""}
                              invalid={
                                validation.touched.contactname &&
                                validation.errors.contactname
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.contactname &&
                            validation.errors.contactname ? (
                              <FormFeedback type="invalid">
                                {validation.errors.contactname}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">Country</Label>
                            <Select 
                              isClearable
                              id="country"
                              name="country"
                              placeholder="Please Select country"
                              onBlur={validation.handleBlur}
                              value={validation?.values?.country}
                              onChange={value => {
                                validation.setFieldValue("country", value)
                              }}
                              styles={customStylesSelect}
                              invalid={
                                validation.touched.country &&
                                  validation.errors.country
                                  ? true
                                  : false
                              }    
                               options={(Countries || [])?.map((el) => ({
                                ...el,
                                label:el?.name,
                                value:el?.name
                               }
                              ))} 
                              classNamePrefix="select2-selection"
                            />
                            {validation.touched.country &&
                            validation.errors.country ? (
                              <FormFeedback type="invalid">
                                {validation.errors.country}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">Register Date</Label>
                            <DatePicker
                              dateFormat="yyyy-MM-dd"
                              value={registerDate}
                              onChange={registerDateChange}
                              className="form-control mb-0 date-icon-back"
                              placeholderText="Select date"
                              //showPopperArrow={true}
                              maxDate={new Date()}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">First Name</Label>
                            <Input
                              name="firstname"
                              type="text"
                              placeholder="Enter First name"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.firstname || ""}
                              invalid={
                                validation.touched.firstname &&
                                validation.errors.firstname
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.firstname &&
                            validation.errors.firstname ? (
                              <FormFeedback type="invalid">
                                {validation.errors.firstname}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">Last Name</Label>
                            <Input
                              name="lastname"
                              type="text"
                              placeholder="Enter Last name"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.lastname || ""}
                              invalid={
                                validation.touched.lastname &&
                                validation.errors.lastname
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.lastname &&
                            validation.errors.lastname ? (
                              <FormFeedback type="invalid">
                                {validation.errors.lastname}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">Category Name</Label>
                            <Input
                              name="category"
                              type="text"
                              placeholder="Enter Category name"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.category}
                              invalid={
                                validation.touched.category &&
                                validation.errors.category
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.category &&
                            validation.errors.category ? (
                              <FormFeedback type="invalid">
                                {validation.errors.category}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Sub-category Name
                            </Label>
                            <Input
                              name="subcategory"
                              type="text"
                              placeholder="Enter sub-Category name"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.subcategory}
                              invalid={
                                validation.touched.subcategory &&
                                validation.errors.subcategory
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.subcategory &&
                            validation.errors.subcategory ? (
                              <FormFeedback type="invalid">
                                {validation.errors.subcategory}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Default Category{" "}
                            </Label>
                            <Input
                              name="defaultCategory"
                              type="text"
                              placeholder="Enter default Category "
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.defaultCategory}
                              invalid={
                                validation.touched.defaultCategory &&
                                validation.errors.defaultCategory
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.defaultCategory &&
                            validation.errors.defaultCategory ? (
                              <FormFeedback type="invalid">
                                {validation.errors.defaultCategory}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">
                              Default Sub_category{" "}
                            </Label>
                            <Input
                              name="default subcategory"
                              type="text"
                              placeholder="Enter sub_Category "
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.defaultsubcategory}
                              invalid={
                                validation.touched.defaultsubcategory &&
                                validation.errors.defaultsubcategory
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.defaultsubcategory &&
                            validation.errors.defaultsubcategory ? (
                              <FormFeedback type="invalid">
                                {validation.errors.defaultsubcategory}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col sm={6}>
                          <div className="mb-3">
                            <Label className="form-label">Pin</Label>
                            <Input
                              name="pincode"
                              type="number"
                              placeholder="Enter pincode "
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.pincode}
                              invalid={
                                validation.touched.pincode &&
                                validation.errors.pincode
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.pincode &&
                            validation.errors.pincode ? (
                              <FormFeedback type="invalid">
                                {validation.errors.pincode}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="mb-3">
                            <Label className="d-block mb-3">
                              Allow User Registration{" "}
                            </Label>
                            <div className="form-check form-check-inline">
                              <Input
                                type="radio"
                                onChange={value =>
                                  validation.setFieldValue(
                                    "allowuserregistration",
                                    value.target.checked
                                  )
                                }
                                defaultChecked={
                                  validation.values.allowuserregistration
                                }
                                name="allowuserregistration"
                                className="form-check-input"
                                id="allowuserregistration1"
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="allowuserregistration1"
                              >
                                Yes
                              </Label>
                            </div>
                            &nbsp;
                            <div className="form-check form-check-inline">
                              <Input
                                type="radio"
                                onChange={value =>
                                  validation.setFieldValue(
                                    "allowuserregistration",
                                    !value.target.checked
                                  )
                                }
                                defaultChecked={
                                  validation.values.allowuserregistration ==
                                  false
                                }
                                name="allowuserregistration"
                                className="form-check-input"
                                id="allowuserregistration2"
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="allowuserregistration2"
                              >
                                No
                              </Label>
                            </div>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="mb-3">
                            <Label className="d-block mb-3">Active </Label>
                            <div className="form-check form-check-inline">
                              <Input
                                type="radio"
                                onChange={value =>
                                  validation.setFieldValue(
                                    "active",
                                    value.target.checked
                                  )
                                }
                                defaultChecked={validation.values.active}
                                name="active"
                                className="form-check-input"
                                id="active1"
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="active1"
                              >
                                Yes
                              </Label>
                            </div>
                            &nbsp;
                            <div className="form-check form-check-inline">
                              <Input
                                type="radio"
                                onChange={value =>
                                  validation.setFieldValue(
                                    "active",
                                    !value.target.checked
                                  )
                                }
                                defaultChecked={
                                  validation.values.active === false
                                }
                                name="active"
                                className="form-check-input"
                                id="active2"
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="active2"
                              >
                                No
                              </Label>
                            </div>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="mb-3">
                            <Label className="d-block mb-3">
                              Domain Restricted Users
                            </Label>
                            <div className="form-check form-check-inline">
                              <Input
                                name="domainrestrictedusers"
                                className="form-check-input"
                                id="domainrestrictedusers1"
                                type="radio"
                                onChange={value =>
                                  validation.setFieldValue(
                                    "domainrestrictedusers",
                                    value.target.checked
                                  )
                                }
                                defaultChecked={
                                  validation.values.domainrestrictedusers
                                }
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="domainrestrictedusers1"
                              >
                                Yes
                              </Label>
                            </div>
                            &nbsp;
                            <div className="form-check form-check-inline">
                              <Input
                                type="radio"
                                onChange={value =>
                                  validation.setFieldValue(
                                    "domainrestrictedusers",
                                    !value.target.checked
                                  )
                                }
                                defaultChecked={
                                  validation.values.domainrestrictedusers ===
                                  false
                                }
                                name="domainrestrictedusers"
                                className="form-check-input"
                                id="domainrestrictedusers2"
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="domainrestrictedusers2"
                              >
                                No
                              </Label>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="text-end">
                            <button
                              type="submit"
                              className="btn btn-primary save-user me-2"
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              color="primary"
                              className="btn btn-secondary"
                              // onClick={handleCancel}
                            >
                              Clear
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Organization
